import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {LicenseManager} from 'ag-grid-enterprise';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

export function getBaseUrl() {
  let url = document.getElementsByTagName('base')[0].href;
  url = url.endsWith('/') ? url.substr(0, url.length - 1) : url;
  return url;
}

LicenseManager.setLicenseKey(
  "InfoSysTrade_Inc_Adrian_Mlodkowski_multi_1_Devs__10_January_2021_[v2]_MTYxMDIzNjgwMDAwMA==2149ed1cf830e2ae72b343f1988389a3"
);


const providers = [
  {provide: 'BASE_URL', useFactory: getBaseUrl, deps: []}
];

if(environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.log(err));

